<div class="alert-templates-result">
  <ui-search
    class="templates-search"
    [debounce]="0"
    [searchQuery]="searchQuery()"
    [placeholder]="'ALERT_TEMPLATES.SEARCH_PLACEHOLDER' | translate"
    (onInput)="onSearchInput($event)"
  ></ui-search>

  <div class="category-row" role="navigation" [attr.aria-label]="'ALERT_TEMPLATES.ALERT_TYPE' | translate">
    <button
      *ngFor="let group of availableGroups(); trackBy: trackByCategory"
      type="button"
      class="category-button"
      (click)="scrollToCategory(categoryForGroup(group))"
    >
      <mat-icon [svgIcon]="categoryIcon(categoryForGroup(group))"></mat-icon>
      <span>{{ group.name | translate }}</span>
    </button>
  </div>

  <ng-container *ngIf="totalCount() > 0; else noTemplates">
    <section
      *ngFor="let group of filteredGroups(); trackBy: trackByCategory"
      class="template-section"
      [attr.data-alert-template-category]="categoryForGroup(group)"
    >
      <h3>{{ group.name | translate }}</h3>

      <div class="templates-grid">
        <article
          *ngFor="let option of group.options; trackBy: trackByTemplate"
          class="template-card"
          [class.disabled-card]="isTemplateDisabled(option)"
          [attr.aria-disabled]="isTemplateDisabled(option)"
          [matTooltip]="disabledTooltip(option) | translate"
          [matTooltipDisabled]="!disabledTooltip(option)"
          matTooltipClass="sidebar-tooltip wide"
        >
          <div class="template-content">
            <div class="template-heading">
              <span class="template-icon">
                <mat-icon [svgIcon]="option.icon"></mat-icon>
              </span>
              <span class="template-name">{{ option.name | translate }}</span>
            </div>

            <div class="template-description" [innerHTML]="templateSentence(option) | multiTranslate"></div>
          </div>

          <div class="template-action">
            <ui-button
              class="use-template-button"
              type="default"
              size="s"
              [disabled]="isTemplateDisabled(option)"
              [text]="'ALERT_TEMPLATES.USE_TEMPLATE' | translate"
              (clickAction)="useTemplate(option)"
            ></ui-button>
            <span *ngIf="option.value.beta" class="beta-badge">
              {{ 'ALERT_TEMPLATES.BETA' | translate }}
            </span>
          </div>
        </article>
      </div>
    </section>
  </ng-container>

  <ng-template #noTemplates>
    <ui-no-data
      class="no-templates"
      imgSrc="assets/add-items.svg"
      [title]="'ALERT_TEMPLATES.NOT_FOUND' | translate"
    ></ui-no-data>
  </ng-template>
</div>
